import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { grantCookiesConsent } from '../../features/cookieConsent';
import BrandPartnerSubscriptionContent from '../../features/registration/components/BrandPartnerSubscriptionContent';

export default function BrandPartnerSubscriptionPage(): React.JSX.Element {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    grantCookiesConsent();
  }, []);

  return (
    <>
      <Helmet>
        <title>swimbooker+ | Subscribe Today!</title>
      </Helmet>
      <div className='grid h-full min-h-screen w-full place-content-center bg-gradient-to-b from-blue to-[#163F60] px-12 py-4 text-white '>
        <div className='mx-auto my-auto w-full min-w-0 max-w-2xl text-center'>
          <BrandPartnerSubscriptionContent />
        </div>
      </div>
    </>
  );
}
